import { style } from '@vanilla-extract/css';

export const genericEmbedHostContainer = style({
  color: 'var(--wt-hyperlink-link-color)',
  wordBreak: 'break-word',
  paddingBottom: '6px',
  paddingTop: '12px',
  textAlign: 'left',
});

export const genericEmbedHostParagraph = style({
  fontFamily: 'var(--wt-hyperlink-font, var(--wt-hyperlink-font-family, inherit))',
  fontSize: 'var(--wt-hyperlink-link-size, 12px)',
  lineHeight: 'var(--wt-generic-embed-host-line-height, 12px)',
  margin: '0',
  wordBreak: 'break-word',
});
